import React from 'react';
import { MessageCircle, Bell, Info, Mail } from 'lucide-react';

const MessageList = ({ messages, loading, onMessageSelect, selectedMessageId }) => {
    const getMessageIcon = (type) => {
        switch (type) {
            case 'system':
                return <Bell className="w-5 h-5 text-blue-500" />;
            case 'personal':
                return <MessageCircle className="w-5 h-5 text-green-500" />;
            case 'broadcast':
                return <Info className="w-5 h-5 text-yellow-500" />;
            default:
                return <Mail className="w-5 h-5 text-gray-500" />;
        }
    };

    if (loading) {
        return (
            <div className="py-12 flex justify-center">
                <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500"></div>
            </div>
        );
    }

    if (messages.length === 0) {
        return (
            <div className="p-6 text-center text-gray-500">
                <Mail className="w-12 h-12 mx-auto mb-4 text-gray-300" />
                <p>目前沒有任何訊息</p>
            </div>
        );
    }

    return (
        <div>
            {messages.map((message) => (
                <div
                    key={message.id}
                    className={`p-4 border-b cursor-pointer hover:bg-gray-50 flex items-center ${selectedMessageId === message.id ? 'bg-blue-50' : ''
                        } ${message.read_status === 'unread' ? 'font-bold' : ''}`}
                    onClick={() => onMessageSelect(message)}
                >
                    <div className="mr-4">
                        {getMessageIcon(message.type)}
                    </div>
                    <div className="flex-1">
                        <div className="flex justify-between items-center mb-1">
                            <h3 className="text-sm">{message.subject}</h3>
                            <span className="text-xs text-gray-500">
                                {new Date(message.created_at).toLocaleString('zh-TW', {
                                    month: '2-digit',
                                    day: '2-digit',
                                    hour: '2-digit',
                                    minute: '2-digit'
                                })}
                            </span>
                        </div>
                        <p className="text-xs text-gray-600 truncate">
                            {message.sender_name} - {message.preview}
                        </p>
                    </div>
                    {message.read_status === 'unread' && (
                        <div className="w-2 h-2 bg-blue-500 rounded-full ml-2"></div>
                    )}
                </div>
            ))}
        </div>
    );
};

export default MessageList;